import axios from "axios";
import { makeAutoObservable, toJS } from "mobx";
import Tool from "../pages/ROI/Tool";
import ToolStore from "./ToolStore";

class NumberOfCasesStore {
  defaultsValues = {};
  data = {};
  changed = {};
  reset() {
    this.defaultsValues = {};
    this.data = {};
    this.changed = {};
  }
  constructor() {
    makeAutoObservable(this);
  }

  setDefaultsValues() {
    this.defaultsValues = this.toFormatJson();
  }
  getData() {
    return toJS(this.data);
  }

  setData(values) {
    this.data = values;
  }
  setChanged(values) {
    this.changed = values;
  }

  setChangedFirst(values) {
    this.changed = values;
  }
  toFormatChanged() {
    var json = {};
    toJS(this.data)[0].value.forEach((x) => {
      if (Array.isArray(x.value)) {
        x.value.forEach((y) => {
          if (Array.isArray(y.value)) {
            y.value.forEach((z) => {
              json["" + y.fieldName + z.fieldName] = false;
            });
          } else {
            json[y.fieldName] = false;
          }
        });
      } else {
        json[x.fieldName] = false;
      }
    });

    return json;
  }
  toFormatJson() {
    var json = {};
    toJS(this.data)[0].value.forEach((x) => {
      if (Array.isArray(x.value)) {
        x.value.forEach((y) => {
          if (Array.isArray(y.value)) {
            y.value.forEach((z) => {
              json["" + y.fieldName + z.fieldName] = z.value;
            });
          } else {
            json[y.fieldName] = y.value;
          }
        });
      } else {
        json[x.fieldName] = x.value;
      }
    });

    return json;
  }
  toUpdateNumberOfCases(newValues) {
    const selected = toJS(this.data)[0];
    var w24 = 0;
    var w25 = 0;
    var w28 = 0;
    var w29 = 0;

    selected.value
      .filter((e) => e.fieldName == "general")[0]
      .value.filter((x) => {
        if (x.fieldName == "newAlignersTreatement") {
          w24 = newValues["newAlignersTreatement" + x.value[0].fieldName];
          w25 = newValues["newAlignersTreatement" + x.value[1].fieldName];
        }
        if (x.fieldName == "newBraces") {
          w28 = newValues["newBraces" + x.value[0].fieldName];
          w29 = newValues["newBraces" + x.value[1].fieldName];
        }
      });

    //general
    selected.value
      .filter((e) => e.fieldName == "general")[0]
      .value.filter((x) => {
        if (
          newValues.hasOwnProperty("newPatientOneYear") &&
          x.fieldName == "newPatientOneYear"
        ) {
          x.value = newValues["newPatientOneYear"];
          x.changed = true;
        }
        if (
          newValues.hasOwnProperty("avgTreatment") &&
          x.fieldName == "avgTreatment"
        ) {
          x.value = newValues["avgTreatment"];
          x.changed = true;
        }

        if (x.fieldName == "newAlignersTreatement") {
          if (
            newValues.hasOwnProperty(
              "newAlignersTreatement" + x.value[0].fieldName
            )
          ) {
            x.value[0].value =
              newValues["newAlignersTreatement" + x.value[0].fieldName];
            x.value[0].changed = true;
          }
          if (
            newValues.hasOwnProperty(
              "newAlignersTreatement" + x.value[1].fieldName
            )
          ) {
            x.value[1].value =
              newValues["newAlignersTreatement" + x.value[1].fieldName];
            x.value[1].changed = true;
          }
        }

        if (x.fieldName == "newBraces") {
          if (newValues.hasOwnProperty("newBraces" + x.value[0].fieldName)) {
            x.value[0].value = newValues["newBraces" + x.value[0].fieldName];
            x.value[0].changed = true;
          }
          if (newValues.hasOwnProperty("newBraces" + x.value[1].fieldName)) {
            x.value[1].value = newValues["newBraces" + x.value[1].fieldName];
            x.value[1].changed = true;
          }
        }
      });
    //alignersCases
    selected.value
      .filter((e) => e.fieldName == "alignersCases")[0]
      .value.filter((x) => {
        //averagePrice
        if (x.fieldName == "averagePrice") {
          if (newValues.hasOwnProperty("averagePrice" + x.value[0].fieldName)) {
            x.value[0].value = newValues["averagePrice" + x.value[0].fieldName];
            x.value[0].changed = true;
          }
          if (newValues.hasOwnProperty("averagePrice" + x.value[1].fieldName)) {
            x.value[1].value = newValues["averagePrice" + x.value[1].fieldName];
            x.value[1].changed = true;
          }
          if (x.value[0].display != -1) {
            x.value[0].display = w24 > 0 ? true : false;
          }
          if (x.value[1].display != -1) {
            x.value[1].display = w25 > 0 ? true : false;
          }
        }
        //addFeeAligners
        if (x.fieldName == "addFeeAligners") {
          if (
            newValues.hasOwnProperty("addFeeAligners" + x.value[0].fieldName)
          ) {
            x.value[0].value =
              newValues["addFeeAligners" + x.value[0].fieldName];
            x.value[0].changed = true;
          }
          if (
            newValues.hasOwnProperty("addFeeAligners" + x.value[1].fieldName)
          ) {
            x.value[1].value =
              newValues["addFeeAligners" + x.value[1].fieldName];
            x.value[1].changed = true;
          }
          if (x.value[0].display != -1) {
            x.value[0].display = w24 > 0 ? true : false;
          }
          if (x.value[1].display != -1) {
            x.value[1].display = w25 > 0 ? true : false;
          }
        }
      });

    //bracesCases
    selected.value
      .filter((e) => e.fieldName == "bracesCases")[0]
      .value.filter((x) => {
        //averagePriceBraces
        if (x.fieldName == "averagePriceBraces") {
          if (
            newValues.hasOwnProperty(
              "averagePriceBraces" + x.value[0].fieldName
            )
          ) {
            x.value[0].value =
              newValues["averagePriceBraces" + x.value[0].fieldName];
            x.value[0].changed = true;
          }
          if (
            newValues.hasOwnProperty(
              "averagePriceBraces" + x.value[1].fieldName
            )
          ) {
            x.value[1].value =
              newValues["averagePriceBraces" + x.value[1].fieldName];
            x.value[1].changed = true;
          }
          if (x.value[0].display != -1) {
            x.value[0].display = w28 > 0 ? true : false;
          }
          if (x.value[1].display != -1) {
            x.value[1].display = w29 > 0 ? true : false;
          }
        }
        //addFeeBraces
        if (x.fieldName == "addFeeBraces") {
          if (newValues.hasOwnProperty("addFeeBraces" + x.value[0].fieldName)) {
            x.value[0].value = newValues["addFeeBraces" + x.value[0].fieldName];
            x.value[0].changed = true;
          }
          if (newValues.hasOwnProperty("addFeeBraces" + x.value[1].fieldName)) {
            x.value[1].value = newValues["addFeeBraces" + x.value[1].fieldName];
            x.value[1].changed = true;
          }
          if (x.value[0].display != -1) {
            x.value[0].display = w28 > 0 ? true : false;
          }
          if (x.value[1].display != -1) {
            x.value[1].display = w29 > 0 ? true : false;
          }
        }
      });

    //preTreatment
    selected.value
      .filter((e) => e.fieldName == "preTreatment")[0]
      .value.filter((x) => {
        //teensYear
        if (
          newValues.hasOwnProperty("teensYear") &&
          x.fieldName == "teensYear"
        ) {
          x.value = newValues["teensYear"];
          x.changed = true;
        }

        //whoAre
        if (newValues.hasOwnProperty("whoAre") && x.fieldName == "whoAre") {
          x.value = newValues["whoAre"];
          x.changed = true;
        }
      });
    //cost
    selected.value
      .filter((e) => e.fieldName == "cost")[0]
      .value.filter((x) => {
        //averageSpend
        if (
          newValues.hasOwnProperty("averageSpend") &&
          x.fieldName == "averageSpend"
        ) {
          x.value = newValues["averageSpend"];
          x.changed = true;
        }

        //ppe
        if (newValues.hasOwnProperty("ppe") && x.fieldName == "ppe") {
          x.value = newValues["ppe"];
          x.changed = true;
        }

        if (x.fieldName == "stafCostHour") {
          if (newValues.hasOwnProperty("stafCostHourdentalAssistant")) {
            x.value[0].value = newValues["stafCostHourdentalAssistant"];
            x.value[0].changed = true;
          }
          if (newValues.hasOwnProperty("stafCostHourtreatmentCoordinator")) {
            x.value[1].value = newValues["stafCostHourtreatmentCoordinator"];
            x.value[1].changed = true;
          }
          if (newValues.hasOwnProperty("stafCostHourfrontDesk")) {
            x.value[2].value = newValues["stafCostHourfrontDesk"];
            x.value[2].changed = true;
          }
        }

        //doctorCostHour
        if (
          newValues.hasOwnProperty("doctorCostHour") &&
          x.fieldName == "doctorCostHour"
        ) {
          x.value = newValues["doctorCostHour"];
          x.changed = true;
        }
        //leadToFirstConsult
        if (
          newValues.hasOwnProperty("leadToFirstConsult") &&
          x.fieldName == "leadToFirstConsult"
        ) {
          x.value = newValues["leadToFirstConsult"];
          x.changed = true;
        }
        //caseAcceptanceRate
        if (
          newValues.hasOwnProperty("caseAcceptanceRate") &&
          x.fieldName == "caseAcceptanceRate"
        ) {
          x.value = newValues["caseAcceptanceRate"];
          x.changed = true;
        }
      });
    this.data[0] = selected;
    this.toUpdateParent();
  }

  toUpdateParent() {
    ToolStore.toUpdate("numberOfCases", this.getData());
  }
}

export default new NumberOfCasesStore();
